import React, { FC } from 'react';
import { Button, Modal } from 'antd';
import { Contact } from 'core/contacts/types';
import './deleteContactModal.scss';

interface DeleteContactModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    contact: Contact | null;
    submitting?: boolean;
}

const DeleteContactModal: FC<DeleteContactModalProps> = ({
    open, onClose, onConfirm, contact, submitting,
}) => (
    <Modal
        open={open}
        onCancel={onClose}
        footer={null}
        width={480}
        className="delete-contact-modal"
        centered>
        <div className="delete-contact-container">
            <h2 className="heading">Delete Contact?</h2>
            <p className="description">
                Are you sure you want to delete
                {contact ? <strong> {contact.name}</strong> : ' this contact'}
                ? This cannot be undone.
            </p>
            <div className="delete-contact-buttons">
                <Button
                    type="primary"
                    className="confirm-button"
                    onClick={onConfirm}
                    loading={Boolean(submitting)}>
                    Delete Contact
                </Button>
                <Button
                    type="default"
                    className="cancel-button"
                    onClick={onClose}
                    disabled={Boolean(submitting)}>
                    Cancel
                </Button>
            </div>
        </div>
    </Modal>
);

DeleteContactModal.defaultProps = {
    submitting: false,
};

export default DeleteContactModal;
